import React, { useEffect, useState } from "react";
import GoogleButton from "../Login/GoogleButton";
import GoogleLoginNative from "../Login/GoogleLoginNative";
import AppleLogin from "../Login/AppleLogin";
import WebAppleLogin from "../Login/WebAppleLogin";
import { trackClientEvent } from "../../../utils/measurement";

// Inside the official app or not, from the page's own surface check
// (public/index.html), made at document start from the WebView itself. The
// old "isFlutterInAppWebViewReady" storage key is not reliable: the app wipes
// web storage on logout, and the browser buttons then rendered inside the app.
const isAppWebView = () =>
  window.QushiSurface
    ? window.QushiSurface.surface !== "browser"
    : typeof window.flutter_inappwebview !== "undefined";

/**
 * `gate` is how the account-creation screen holds Apple / Google back until the
 * legal + age checkbox is ticked. It is intercepted here, in the capture phase
 * of a wrapper, rather than inside each provider button: Google, native Google,
 * web Apple and native Apple are four different components with four different
 * click handlers, and one interception point cannot drift out of step with the
 * checkbox the way four could. Screens that legitimately have no checkbox (the
 * sign-in screen) pass no gate and behave exactly as before.
 */
const SocialLogin = ({ gate, signUp = false }) => {
  const blockUntilAccepted = (e) => {
    if (!gate || gate.accepted) {
      // On an account-creation screen, an Apple / Google tap that gets past
      // the checkbox starts a registration (Core §6.3 sign_up_start).
      const method = signUp && e.target.closest?.("[data-signup-method]")?.dataset.signupMethod;
      if (method) trackClientEvent("sign_up_start", { method });
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    if (typeof gate.onBlocked === "function") gate.onBlocked();
  };

  const [isFlutterWebViewReady] = useState(isAppWebView);
  const [deviceType, setDeviceType] = useState("Unknown");

  useEffect(() => {
    const userAgent = navigator.userAgent;

    let device_type = "Unknown";

    if (/Android/i.test(userAgent)) {
      device_type = "A"
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      device_type = "I"
    } else {
      device_type = "W"
    }

    setDeviceType(device_type);
  }, []); // Run once when component mounts


  return (
    <div
      onClickCapture={blockUntilAccepted}
      aria-disabled={gate && !gate.accepted ? "true" : undefined}
    >
      <div className="flex justify-between w-full mt-2" data-signup-method="apple">
        {deviceType === "I" && isFlutterWebViewReady && <AppleLogin />} {/* Render AppleLogin component if device is iOS */}
      </div>

      <div className="flex justify-between w-full mt-2" data-signup-method="apple">
        {!isFlutterWebViewReady && <WebAppleLogin />} {/* Render WebAppleLogin component for Web */}
      </div>


      <div className="flex justify-between w-full mt-2" data-signup-method="google">
        {/* Inside the app (iOS and Android) Google sign-in is native only: the
            web OAuth flow is refused in an embedded WebView (origin_mismatch)
            and strands the page while the native sign-in completes. */}
        {isFlutterWebViewReady ? (
          <GoogleLoginNative />
        ) : (
          <GoogleButton />
        )}
      </div>

    </div>
  );
};

export default SocialLogin;
